'use client';
import moment from 'moment';
import {useTranslations} from 'next-intl';

export default function DateBlock({date}: {date: Date}) {
  const w = useTranslations('Date');
  const weekday = {
    Monday: w('Monday'),
    Tuesday: w('Tuesday'),
    Wednesday: w('Wednesday'),
    Thursday: w('Thursday'),
    Friday: w('Friday'),
    Saturday: w('Saturday'),
    Sunday: w('Sunday')
  };

  const formatDate = (dateStr: Date) => {
    const date = moment(dateStr);
    return date
      .format(w('dateFormat'))
      .replace(
        date.format('dddd'),
        weekday[date.format('dddd') as keyof typeof weekday]
      );
  };

  return <>{formatDate(date)}</>;
}
